// extracted by mini-css-extract-plugin
module.exports = {"recomendationsList":"RecommendedCarsCard_recomendationsList__kG7oH","recomendationsList__list":"RecommendedCarsCard_recomendationsList__list__6mJ9S"};